module.exports = __webpack_public_path__ + "static/media/montiapp-large-dark.96aa617c.jpeg";